import fi from "./trigger-condition.js";
export default class ur {
  constructor(t) {
    (this.rf = t), (this.rf = t);
  }
  sf(t) {
    return null == this.rf || fi.ef(t[0], this.rf);
  }
  static fromJson(t) {
    return new ur(t ? t.campaign_id : null);
  }
  gt() {
    return this.rf;
  }
}
